import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import {
  TablePagination,
  TableFooter,
  Button,
  Stack,
  Typography,
  TableBody,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  tableCellClasses,
  Tooltip,
  useMediaQuery,
  Menu,
  MenuItem,
  Card,
  CardHeader,
  IconButton,
  CardContent,
  FormControl,
  Select,
} from "@mui/material";
import Grid from "@material-ui/core/Grid";
import {
  deleteRoom,
  getRoomList
} from "../../../paymentRequest";
import { useDispatch, useSelector } from "react-redux";
import {
  hideApiLoader,
  setUserLoginData,
  showApiLoader,
} from "../../../../redux/tool-webjam/actions";
import { useDevice, usePrevious } from "../../../Utils";
import ConfirmationAlert from "../ConfirmationAlert";
import { messages } from "../messages";
import {
  NotificationType,
  paginationObject,
  PaymentPages,
  SEARCH_DELAY_TIME,
  updateJammingCapability,
} from "../Utils";
import {
  setHostedRoom,
  setNotificationMessage,
  setPaymentSelectedPage,
} from "../payment-reducer/actions";
import { FEATURE_CUSTOM_PAYMENT, FEATURE_CUSTOM_REDUX } from "../../../../constant";
import SearchInput from "../helperComponent/SearchInput";
import { Constant } from "../../../../../webjam/constant";
import { copyText } from "../../../../../base/util/copyText.web";
import { dateFormatter } from "../AbstractHelperComponent";
import { getBaseConfig, isMobileBrowserC, isSocialMobileApp } from "../../../../Utils";
import { updateUserJamStateReq } from "../../../Request.d";
import { Translate } from "../../../../../webjam/language";
import { ct, dynamicMessageLocale } from "../../../../constant-Utils";
import { socketEmit } from "../../../../../../../socket";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "var(--theme-primary-color)",
    color: theme.palette.common.white,
    fontSize: 16,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 16,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function HostedRoom(props) {
  const [page, setPage] = useState(0);

  const [pageNo, setPageNo] = useState({
    currentPage: 0,
    nextPage: 0,
    prevPage: 0,
  });
  const { userLoginData } = useSelector((store) => store[FEATURE_CUSTOM_REDUX]);
  const [totalRecord, setTotalRecord] = useState(0);
  const [recordPerPage, setRecordPerPage] = useState(10);
  const [list, setList] = useState([]);
  const [isConfirming, setIsConfirming] = useState(false);
  const [roomId, setRoomId] = useState(null);
  const [pageSearch, setPageSearch] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = useState(null);
  const [currentActiveId, setCurrentActiveId] = useState(null);
  const open = Boolean(anchorEl);
  const copyUrl = (roomName) => {
    const url = createMeetingLink(roomName);
    copyText(url);
    dispatch(
      setNotificationMessage({
        isOpen: true,
        type: NotificationType.SUCCESS,
        message: ct("rta-trmc.dashboard.myRoom.meetingLink"),
      })
    );
  };

  const createMeetingLink = (roomName) => {
    const socialUrl = Constant.App.socialUrl;
    return socialUrl + "/webcam/" + roomName;
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setCurrentActiveId(event.currentTarget.id);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const { paymentHostedRoom } = useSelector(
    (state) => state[FEATURE_CUSTOM_PAYMENT]
  );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const { target } = event;
    setRecordPerPage(+target.value);
    setPage(0);
  };

  useEffect(() => {
    dispatch(showApiLoader());
    fetchData();
  }, []);

  // Page change pagination
  const prevPage = usePrevious(page);
  useEffect(() => {
    let p = 0;

    if (prevPage != undefined && prevPage < page) {
      p = pageNo.nextPage;
    } else if (prevPage != undefined && prevPage > page) {
      p = pageNo.prevPage;
    }
    if (prevPage != undefined && p > 0) {

      fetchData("", "?page=" + p + "&limit=" + recordPerPage);
    }
  }, [page]);

  // Handle number of record per page
  const prevPerPage = usePrevious(recordPerPage);
  useEffect(() => {

    if (prevPerPage != undefined && prevPerPage != recordPerPage) {
      if (recordPerPage > 0) {
        fetchData("", "?page=" + 1 + "&limit=" + recordPerPage);
      }
    }
  }, [recordPerPage]);

  const handleSearch = (e, isEmpty = false) => {
    setPageSearch(isEmpty ? "" : e?.target?.value);
  };

  let prevSearch = usePrevious(pageSearch);
  useEffect(() => {
    if (prevSearch != undefined) {
      var e = setTimeout(() => {
        fetchData();
      }, SEARCH_DELAY_TIME);
      return () => clearTimeout(e);
    }
  }, [pageSearch]);

  // if rooms api failed due to token missing, then we hit api again 
  function* _reCallFetchData() {
    let timer;
    timer = setTimeout(() => {
      fetchData({}, "?page=1&limit=10", false);
    }, 1000);
    yield { callTime: 1 };
    clearTimeout(timer);
    timer = setTimeout(() => {
      fetchData({}, "?page=1&limit=10", false);
    }, 2000);
    fetchData();
    yield { callTime: 2 };
    clearTimeout(timer);
    timer = setTimeout(() => {
      fetchData({}, "?page=1&limit=10", false);
    }, 5000);
    yield { callTime: 3 };
  }
  const reCallFetchData = _reCallFetchData();

  const fetchData = (data = {}, pagination = "?page=1&limit=10", showLoader = true) => {
    if (showLoader) {
      setIsLoading(true);
      dispatch(showApiLoader());
    }

    data = Object.assign(
      {
        search: pageSearch,
      },
      data
    );

    getRoomList(data, "hosted", pagination)
      .then((res) => {
        if (res.status == 1) {
          let data = res.data.data;

          dispatch(
            setHostedRoom({
              list: [...data.rooms],
              pagination: data.pagination,
            })
          );
          setTotalRecord(data.pagination.count);
          setRecordPerPage(data.pagination.page.perPage);
          setPageNo(data.pagination.page);
        } else {
          const genFn = reCallFetchData.next();

          dispatch(
            setHostedRoom({
              list: [],
              pagination: paginationObject,
            })
          );
          setTotalRecord(0);
          setRecordPerPage(10);
          setPageNo({
            currentPage: 0,
            nextPage: 0,
            prevPage: 0,
          });
        }
      })
      .finally(() => {
        dispatch(hideApiLoader());
        setIsLoading(false);
      });
  };

  // type 1 is update, 0 is for delete
  const handleRoomAction = (id_room, type, row = null) => {

    setRoomId(id_room);
    if (type == 1) {
      dispatch(setPaymentSelectedPage(PaymentPages.UPDATE_ROOM, id_room, row));
    } else if (type == 0) {
      setIsConfirming(true);
    } else {
      // social url change code
      // let socialAllowed = getBaseConfig("socialAllowed");
      // if (socialAllowed == true) {
      //   let socialReferrerUrl = getBaseConfig("socialReferrerUrl");
      //   let refreshUrl = socialReferrerUrl + "/" + id_room;
      //   window.parent.location.href = refreshUrl;
      // }else {
      //     window.open(window.location.origin + "/" + id_room, "_self")
      // }

      if (isSocialMobileApp()) {
        if (getBaseConfig("webViewApp")) { // For running project in web view application
          let socialReferrerUrl = getBaseConfig('appReferrerUrl')
          let refreshUrl = socialReferrerUrl + '/' + id_room;
          window.location.href = refreshUrl
        } else { // For running project in react native application
          socketEmit('mobile_room_start', {
            roomName: id_room,
            userId: userLoginData?.user?.id
          });
        }
        return false;

      } else {
        // social url change code
        let socialAllowed = getBaseConfig("socialAllowed");
        if (socialAllowed == true) {
          window.parent.location.href = getBaseConfig("socialReferrerUrl") + "/" + id_room;
        } else {
          window.open(window.location.origin + "/" + id_room, "_self")
        }
      }
    }
  };

  const handleConfirmAction = (type) => {
    setIsConfirming(false);
    if (type) {
      dispatch(showApiLoader());
      deleteRoom({
        id: roomId,
      })
        .then(async (res) => {
          if (res.status == 1) {
            setList(list.filter((e) => e._id != roomId));
            dispatch(
              setNotificationMessage({
                isOpen: true,
                type: NotificationType.SUCCESS,
                message: await dynamicMessageLocale(res.data.message),
              })
            );
          } else {
            dispatch(
              setNotificationMessage({
                isOpen: true,
                type: NotificationType.SUCCESS,
                message: await dynamicMessageLocale(res.data.message),
              })
            );
          }
        })
        .finally(() => {
          fetchData();
          dispatch(hideApiLoader());
          setTimeout(async () => {
            dispatch(
              setNotificationMessage({
                isOpen: false,
                type: NotificationType.SUCCESS,
                message: await dynamicMessageLocale(res.data.message),
              })
            );
          }, 5000);
        });
      console.log("delete this room");
    } else {
      console.log("not delete");
    }
  };

  const handleCreateRoom = () => {
    dispatch(setPaymentSelectedPage(PaymentPages.CREATE_ROOM));
  };

  const isDesktop = useMediaQuery("(min-width:600px)");
  const tableContainer = {
    left: 0,
    right: 0,
    top: 0
  };
  const tableWrapper = {
    width: "100%",
    overflow: "hidden",
    position: "relative",
  };
  const { isMobile, isTablet } = useDevice();

  let _jammingInfo = userLoginData && userLoginData.jamming_capability_rooms || [];
  const [jammingInfo, setJammingInfo] = useState(_jammingInfo);

  const handleChangeJammingStatus = async (event, room_name) => {
    _jammingInfo = await updateJammingCapability(_jammingInfo, room_name, event.target.value);
    dispatch(setUserLoginData({ ...userLoginData, jamming_capability_rooms: _jammingInfo }))
    setJammingInfo([..._jammingInfo]);
    fetchData();
  }

  if (isLoading) {
    return <>{ct("rta-trmc.waitLoading")}</>
  }

  return (
    <>
      {(isMobile || isTablet) && <Menu
        id={"basic-popup"}
        anchorEl={anchorEl}
        open={open}
        autoFocus={false}
        className="root muiMenuWrapper"
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-popup",
        }}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {/* <MenuItem
                  sx={{ paddingTop: "0px", paddingBottom: "0px" }}
                  onClick={() => {
                    const activeObj = paymentHostedRoom.list.find(
                      (r) => r?._id === currentActiveId
                    );
                    handleRoomAction(activeObj.groupName, 2);
                    handleClose();
                  }}
                >
                  <i className="fa fa-video-camera payment-theme-icon pointer theme-font-color"></i>
                  <Typography>Start Room</Typography>
                </MenuItem> */}
        <MenuItem
          id="m-edit-room"
          sx={{ paddingTop: "0px", paddingBottom: "0px" }}
          onClick={() => {
            const activeObj = paymentHostedRoom.list.find(
              (r) => r?._id === currentActiveId
            );
            handleRoomAction(currentActiveId, 1, activeObj);
            handleClose();
          }}
        >
          <i className="fa fa-pencil payment-theme-icon pointer theme-font-color edit-mobile-icon"></i>
          <Typography>{ct("rta-trmc.dashboard.myRoom.edit")}</Typography>
        </MenuItem>
        <MenuItem
          id="m-copy-link"
          sx={{ paddingTop: "0px", paddingBottom: "0px" }}
          onClick={(e) => {
            e.preventDefault();
            const activeObj = paymentHostedRoom.list.find(
              (r) => r?._id === currentActiveId
            );
            copyUrl(activeObj?.groupName);
            handleClose();
          }}
        >
          <i className="fa fa-clone my-recordings-icons theme-font-color edit-mobile-icon" />
          <Typography>{ct("rta-trmc.dashboard.myRoom.copyLink")}</Typography>
        </MenuItem>
        {/* <MenuItem
                  id="m-delete-room"
                  sx={{ paddingTop: "0px", paddingBottom: "0px" }}
                  onClick={(e) => {
                    e.preventDefault();
                    handleRoomAction(currentActiveId, 0);
                    handleClose();
                  }}
                >
                  <i
                    className="fa fa-trash-o payment-theme-icon pointer"
                    style={{ color: "var(--theme-error-color)" }}
                  ></i>
                  <Typography>Delete</Typography>
                </MenuItem> */}
      </Menu>}
      {isConfirming && (
        <ConfirmationAlert
          handleConfirmAction={handleConfirmAction}
          title={ct("rta-trmc.dashboard.subscription.deleteConfirm") + " room?"}
        />
      )}
      <div className="payment-table-custom-cont">
        <Grid
          container
          spacing={2}
          className="payment-hosted-room-list-container mb-2"
        >
          <Grid item xs={12} md={6} lg={6} sm={6} className="text-left">
            <Button
              id="add-room"
              variant="contained"
              onClick={() => handleCreateRoom(true)}
              sx={{
                fontSize: 14,
                backgroundColor: "var(--theme-primary-color)",
                height: 50,
              }}
              className="p-theme-btn"
            >
              {ct("rta-trmc.dashboard.myRoom.addRoom")}
            </Button>
          </Grid>
          <Grid item xs={12} md={6} lg={6} sm={6}>
            <SearchInput
              pageSearch={pageSearch}
              handleSearch={handleSearch}
              classes={`pull-right ${!isDesktop ? "w-100" : ""}`}
              width={`${!isDesktop ? "100%" : undefined}`}
            />
          </Grid>
        </Grid>
        {!isMobile && !isTablet && <div style={tableWrapper}>
          <TableContainer style={!isDesktop ? tableContainer : {}}>
            <Table id="hosted-room-table" aria-label="customized table" stickyHeader >
              <TableHead>
                <TableRow>
                  <StyledTableCell>{ct("rta-trmc.dashboard.myRoom.roomName")}</StyledTableCell>
                  <StyledTableCell>{ct("rta-trmc.dashboard.myRoom.type")}</StyledTableCell>
                  <StyledTableCell>{ct("rta-trmc.dashboard.myRoom.publish")}</StyledTableCell>
                  <StyledTableCell>{ct("rta-trmc.dashboard.myRoom.category")}</StyledTableCell>
                  <StyledTableCell>{ct("rta-trmc.dashboard.myRoom.paid")}</StyledTableCell>
                  <StyledTableCell>{ct("rta-trmc.dashboard.myRoom.roomAmount")}</StyledTableCell>
                  <StyledTableCell>{ct("rta-trmc.dashboard.myRoom.startDate")}</StyledTableCell>
                  <StyledTableCell className={isMobile ? 'stickyActionHeader' : ''} >
                    {ct("rta-trmc.dashboard.myRoom.action")}
                  </StyledTableCell>
                  {getBaseConfig("showJammingCapaility") &&
                    <StyledTableCell>{ct("rta-trmc.dashboard.myRoom.jammingCapability")}</StyledTableCell>
                  }
                </TableRow>
              </TableHead>
              {/* table body */}
              <TableRowComponent
                paymentHostedRoom={paymentHostedRoom}
                isLoading={isLoading}
                handleRoomAction={handleRoomAction}
                refreshData={fetchData}
              />
              {!isMobile && paymentHostedRoom?.list?.length > 0 ? (
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[10]}
                      count={totalRecord}
                      rowsPerPage={recordPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      sx={{
                        fontSize: 16,
                      }}
                      SelectProps={{
                        MenuProps: { classes: { paper: "invite-pagination" } },
                      }}
                      className="welcome-pagination"
                    />
                  </TableRow>
                </TableFooter>
              ) : null}
            </Table>
          </TableContainer>
        </div>}
        {/* Mobile cards start here */}
        {(isMobile || isTablet) && !isLoading && !paymentHostedRoom?.list?.length && (<div className="w-100 text-center" style={{ fontSize: '16px' }}>{ct("Translate.typography.noRecordFound")}</div>)}
        {(isMobile || isTablet) && paymentHostedRoom.list.map((row, i) => {
          return (<Card className="mb-5 custom-card-wrapper" key={i}>
            <CardHeader
              sx={{ paddingBottom: "0px" }}
              action={
                <IconButton data-id={`ellipsis-${i}`} id={row?._id} onClick={handleClick} aria-label="settings">
                  <i
                    className="fa fa-ellipsis-h pointer theme-font-color"
                    aria-hidden="true"
                  ></i>
                </IconButton>
              }
              title={<div className="d-flex"><span><b className="nameTitlewrapper">{ct("rta-trmc.dashboard.myRoom.roomName")} : </b></span><span className="ml-2 NameContentWrapper">{row?.groupName || "-"}</span></div>}
            />

            <CardContent style={{ paddingTop: "0px" }}>
              <div className="d-flex"><Typography><b>{ct("rta-trmc.dashboard.myRoom.type")} :</b></Typography>
                <Typography className="ml-2">{row.private ? ct("rta-trmc.dashboard.myRoom.private") : ct("rta-trmc.dashboard.myRoom.public")}</Typography>
              </div>
              <div className="d-flex"><Typography><b>{ct("rta-trmc.dashboard.myRoom.publish")} :</b>
              </Typography><Typography className="ml-2">{row.publish ? ct("Translate.buttonTitle.yesSmall") : ct("Translate.buttonTitle.noSmall")}</Typography>
              </div>
              <div className="d-flex"><Typography><b>{ct("rta-trmc.dashboard.myRoom.category")} :</b>
              </Typography><Typography className="ml-2">{row?.category ? ct("rta-trmc.dialogs." + row?.category.toLowerCase()) : ct("rta-trmc.dashboard.myRoom.nA")}</Typography>
              </div>
              <div className="d-flex"><Typography><b>{ct("rta-trmc.dashboard.myRoom.paid")} :</b>
              </Typography><Typography className="ml-2">{row.paid ? ct("Translate.buttonTitle.yesSmall") : ct("Translate.buttonTitle.noSmall")}</Typography>
              </div>
              <div className="d-flex"><Typography><b>{ct("rta-trmc.dashboard.myRoom.roomAmount")} :</b></Typography>
                <Typography className="ml-2">{row?.paidDetail?.amount ? "$" + row?.paidDetail?.amount : ct("rta-trmc.dashboard.myRoom.nA")}</Typography>
              </div>
              <div className="d-flex"><Typography><b>{ct("rta-trmc.dashboard.myRoom.startDate")} :</b></Typography>
                <Typography className="ml-2">{row.startDate ? dateFormatter(row.startDate, "YYYY-MM-DD") : ct("rta-trmc.dashboard.myRoom.nA")}</Typography>
              </div>
              {getBaseConfig("showJammingCapaility") &&
                <div className="mt-2"><Typography><b>{ct("rta-trmc.dashboard.myRoom.jammingCapability")} :</b></Typography>
                  < div >
                    <JammingPreferenceSelect row={row} jammingInfo={jammingInfo.length ? jammingInfo : _jammingInfo} handleChangeJammingStatus={handleChangeJammingStatus} />
                  </div></div>
              }
              <div className="w-100 mt-2"><Button
                id={`m-start-room-${i}`}
                variant="contained"
                fullWidth
                size="small"
                startIcon={<i className="fa fa-video-camera"></i>}
                onClick={() => handleRoomAction(row.groupName, 2)}
                sx={{
                  fontSize: 14,
                  backgroundColor: "var(--theme-primary-color)",
                }}
                className="p-theme-btn"
              >{ct("rta-trmc.dashboard.myRoom.startRoom")}</Button></div>
            </CardContent>
          </Card>)
        })}
        {/* Mobile cards end here */}
        {(isMobile || isTablet) && paymentHostedRoom?.list?.length > 0 ? (<div className="mobile-pagination-wrapper">
          <TablePagination
            id="m-pagination"
            rowsPerPageOptions={[10]}
            count={totalRecord}
            rowsPerPage={recordPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{
              fontSize: 16,
            }}
            SelectProps={{
              MenuProps: { classes: { paper: "invite-pagination" } },
            }}
            className="welcome-pagination mobile-pagination"
          />
        </div>) : null}
      </div>
    </>
  );
}

export default HostedRoom; // My Rooms

const TableRowComponent = ({
  paymentHostedRoom,
  isLoading,
  handleRoomAction,
  refreshData
}) => {
  const dispatch = useDispatch();
  // const isMobile = isMobileBrowserC();
  const { isMobile } = useDevice();
  const { userLoginData } = useSelector((store) => store[FEATURE_CUSTOM_REDUX]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentActiveId, setCurrentActiveId] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setCurrentActiveId(event.currentTarget.id);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const copyUrl = (roomName) => {
    const url = createMeetingLink(roomName);
    copyText(url);
    dispatch(
      setNotificationMessage({
        isOpen: true,
        type: NotificationType.SUCCESS,
        message: ct("rta-trmc.dashboard.myRoom.meetingLink"),
      })
    );
  };

  const createMeetingLink = (roomName) => {
    const socialUrl = Constant.App.socialUrl;
    return socialUrl + "/webcam/" + roomName;
  };
  let _jammingInfo = userLoginData && userLoginData.jamming_capability_rooms || [];

  const [jammingInfo, setJammingInfo] = useState([..._jammingInfo]);
  const handleChangeJammingStatus = async (event, room_name) => {
    _jammingInfo = await updateJammingCapability(_jammingInfo, room_name, event.target.value);
    dispatch(setUserLoginData({ ...userLoginData, jamming_capability_rooms: _jammingInfo }))
    setJammingInfo([..._jammingInfo])
    refreshData();
  }

  return (
    <>
      <TableBody>
        {!isLoading && !paymentHostedRoom?.list?.length && (
          <StyledTableRow className="w-100">
            <StyledTableCell
              colSpan={9}
              style={{ textAlign: "-webkit-center" }}
            >
              {ct("Translate.typography.noRecordFound")}
            </StyledTableCell>
          </StyledTableRow>
        )}
        {paymentHostedRoom.list.map((row, i) => (
          <React.Fragment key={i}>
            <TableRow key={row._id} hover>
              <StyledTableCell>
                <Typography
                  sx={{
                    maxWidth: 200,
                    wordBreak: "break-word",
                  }}
                >
                  {row.groupName}
                </Typography>
              </StyledTableCell>
              <StyledTableCell>
                {row.private ? ct("rta-trmc.dashboard.myRoom.private") : ct("rta-trmc.dashboard.myRoom.public")}
              </StyledTableCell>
              <StyledTableCell>{row.publish ? ct("Translate.buttonTitle.yesSmall") : ct("Translate.buttonTitle.noSmall")}</StyledTableCell>
              <StyledTableCell>{row?.category ? ct("rta-trmc.dialogs." + row?.category.toLowerCase()) : "-"}</StyledTableCell>
              <StyledTableCell>{row.paid ? ct("Translate.buttonTitle.yesSmall") : ct("Translate.buttonTitle.noSmall")}</StyledTableCell>
              <StyledTableCell>
                {row?.paidDetail?.amount ? "$" + row?.paidDetail?.amount : "-"}
              </StyledTableCell>

              <StyledTableCell>
                {row.startDate
                  ? dateFormatter(row.startDate, "YYYY-MM-DD")
                  : "-"}
              </StyledTableCell>
              <StyledTableCell className={isMobile ? 'stickyActionColumn' : ''} >
                {isMobile ? (
                  <i
                    id={row._id}
                    onClick={handleClick}
                    className="fa fa-ellipsis-h pointer theme-font-color"
                    aria-hidden="true"
                  ></i>
                ) : (
                  <Stack direction="row" spacing={2}>
                    <Tooltip title={ct("rta-trmc.dashboard.myRoom.startRoom")} arrow>
                      <i
                        className="fa fa-video-camera payment-theme-icon pointer theme-font-color"
                        id={`start-room-${i}`}
                        onClick={() => handleRoomAction(row.groupName, 2)}
                      ></i>
                    </Tooltip>
                    <Tooltip title={ct("rta-trmc.dashboard.myRoom.edit")} arrow>
                      <i
                        onClick={() => handleRoomAction(row._id, 1, row)}
                        className="fa fa-pencil pointer theme-font-color"
                        id={`edit-room-${i}`}
                        aria-hidden="true"
                      ></i>
                    </Tooltip>
                    <Tooltip title={createMeetingLink(row?.groupName)} arrow>
                      <i
                        className="fa fa-clone my-recordings-icons theme-font-color"
                        onClick={(e) => {
                          e.preventDefault();
                          copyUrl(row?.groupName);
                        }}
                        id={`copy-link-${i}`}
                      />
                    </Tooltip>
                    {/* <Tooltip title="Delete" arrow>
                      <i
                        id={`delete-room-${i}`}
                        className="fa fa-trash-o payment-theme-icon pointer"
                        style={{ color: "var(--theme-error-color)" }}
                        onClick={() => handleRoomAction(row._id, 0)}
                      ></i>
                    </Tooltip> */}
                  </Stack>
                )}
              </StyledTableCell>
              {getBaseConfig("showJammingCapaility") &&
                <StyledTableCell>
                  <JammingPreferenceSelect row={row} jammingInfo={jammingInfo.length ? jammingInfo : _jammingInfo} handleChangeJammingStatus={handleChangeJammingStatus} />
                </StyledTableCell>}
            </TableRow>
          </React.Fragment>
        ))}
      </TableBody>
    </>
  );
};


export const JammingPreferenceSelect = ({ row, jammingInfo, handleChangeJammingStatus }) => {
  const { isMobile } = useDevice();
  return <FormControl fullWidth className={isMobile ? "mob-jamming-select" : "desktop-jamming-select"}>
    <Select
      displayEmpty
      name="jammingCapibility"
      value={(Array.isArray(jammingInfo) && jammingInfo?.find((item) => item.room_name === row?.groupName)?.status) || 1}
      onChange={(event) => handleChangeJammingStatus(event, row?.groupName)}
      sx={{ fontSize: 14 }}
      className="jamming-capability-select"
    >
      <MenuItem sx={{ fontSize: 14 }} value={1}>{ct("Translate.typography.askEveryTime")}</MenuItem>
      <MenuItem sx={{ fontSize: 14 }} value={2}>{ct("Translate.typography.liveJamming")}</MenuItem>
      <MenuItem sx={{ fontSize: 14 }} value={3}>{ct("Translate.typography.noLiveJamming")}</MenuItem>
    </Select>
  </FormControl>
}